import RecordService from "@/services/RecordService";

// sending currency not in corridor key, because sending countries always has only 1 currency
// segment included so STANDARD and FIRST_TRANSACTION rows for the same corridor get distinct keys
let getCorridorKey = cr => {
  return `${cr.sendingCountryIso3}_${cr.receiveCountryIso3}_${cr.receiveCurrency}_${cr.serviceCode}_${cr.providerRate}_${cr.segment || 'STANDARD'}`;
};

let prepareRecord = (record, index) => ({
  ...record,
  key: `${getCorridorKey(record)}_${index}`,
  automaticallyRate: record.manualRate === null,
  calcEndUserRate:
    record.manualRate === null ? record.calcEndUserRate : record.manualRate
});

let preparePreviewRecord = (record, index) => ({
  ...record,
  key: `${getCorridorKey(record)}_${index}`
});

const state = () => ({
  list: [],
  listPreview: [],
  pagination: {
    pageIndex: 0,
    pageSize: 0,
    totalElements: 0,
    totalPages: 0
  },
  tenants: null
});

const getters = {
  getList: state => state.list.map(prepareRecord),
  getListPreview: state => state.listPreview.map(preparePreviewRecord),
  getPagination: state => state.pagination,
  getTenants: state => state.tenants
};

const mutations = {
  setList(state, value) {
    state.list = value;
  },
  setListPreview(state, value) {
    state.listPreview = value;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setTenants(state, value) {
    state.tenants = value;
  }
};

const actions = {
  getList({ commit }, payload) {
    return RecordService.getList(payload).then(({ list, pagination }) => {
      commit("setList", list);
      commit("setPagination", pagination);
    });
  },
  create(_, payload) {
    return RecordService.create(payload);
  },
  update(_, payload) {
    return RecordService.update(payload);
  },
  delete(_, payload) {
    return RecordService.delete(payload);
  },
  uploadCsv(_, payload) {
    return RecordService.uploadCsv(payload);
  },
  previewCsv({ commit }, payload) {
    return RecordService.previewCsv(payload).then(list => {
      commit("setListPreview", list);
    });
  },
  clearPreviewList({ commit }) {
    commit("setListPreview", []);
  },
  downloadCsv(_, payload) {
    return RecordService.downloadCsv(payload);
  },
  clearManualRates(_, payload) {
    return RecordService.clearManualRates(payload);
  },
  getCornerCases(_, payload) {
    return RecordService.getCornerCases();
  },
  getTenants({ commit }, payload) {
    return RecordService.getTenants()
      .then((res) => {
        commit("setTenants", res.data);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
